import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-78244bab"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "see-if-root-page main-scroll-topbar-content"
};
const _hoisted_2 = {
  class: "detail-content"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "main-img",
  src: "https://summit-img.geekpark.net/if2023/if-badge-detail.png"
}, null, -1));

const _hoisted_4 = {
  class: "text-tip"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "温馨提示：", -1));

const _hoisted_6 = /*#__PURE__*/_createTextVNode("若已领取，可点击");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("跳转GDC藏品室查看");

import TopNavigator from "../components/TopNavigator.vue";
export default {
  __name: 'SeeIfBadge',
  props: {},

  setup(__props) {
    const props = __props;

    const goGDCPage = () => {
      window.location.href = 'https://if0001.geekpark.net/collection-room';
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(TopNavigator, {
        title: "我的IF徽章"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", null, [_hoisted_6, _createElementVNode("span", {
        class: "highlight-text",
        onClick: _cache[0] || (_cache[0] = $event => goGDCPage())
      }, "「查看我的IF徽章」"), _hoisted_7])])])])], 64);
    };
  }

};